<template>

<ul class="app-bar-menu">
    <span style="display:none">{{userRole}}</span>
    <li v-for="mi in menuItems" :key="mi.id">
        <a @click="onMenuItem(mi)">
            <img v-if="mi.icon" :src="mi.icon"/> 
            <span v-if="mi.html" v-html="mi.html"></span>
            <span>{{mi.title}}</span> 
        </a>
    </li>
</ul>
</template>

<script>
import _ from 'underscore';
const menuItems=[
    {
        id:'0',
        title:'',
        action:'home',
        active:false,
        path:'/admin/',
        html:'<span class="mif-home mif-2x"></span>'
    }
];
const adminMenuItems=[
    {
        id:'1',
        title:'Ενότητες',
        action:'articles',
        active:false,
        path:'/admin/articles',
        html:''
    }
];
export default {
    watch:{
        '$route': function(to, from) {
            this.setActiveItems(to);
        }
    },
    computed:{
        userRole(){
            if (this.$store.state.user){
                this.menuItems.length=0;
                this.menuItems.push(...menuItems);
                if (this.$store.state.user.roleId==0){
                    this.menuItems.push(...adminMenuItems);
                }
                return this.$store.state.user.roleId;
            }
            else{
                this.menuItems=[
                    {
                        id:'0',
                        title:'',
                        action:'login',
                        active:false,
                        path:'/admin/signin',
                        html:'<span class="mif-home mif-2x"></span>'
                    }
                ]
            }
            return 100;
        },
    },
    data(){
        return{
            menuItems:[]
        }
    },
    mounted(){
    },
    methods:{
        setActiveItems(to){
            let path=to.path;
            let fullPath=to.fullPath;
            let homeMenuItem=_.findWhere(this.menuItems,{path:'/admin/'});
            let activeMenuItems=[];
            if (path=='/admin/'){
                activeMenuItems.push(homeMenuItem);
            }
            else{
                activeMenuItems=_.filter(this.menuItems,p=>path.indexOf(p.path)!=-1 && p.path!='/admin/');
            }
            
            for (let mi of this.menuItems)
                mi.active=false;

            let breadcrumb='';
            for (let ami of activeMenuItems){
                ami.active=true;
                breadcrumb+='>'+ami.title;
            }
            this.$store.commit('setBreadcrumb',breadcrumb.substring(1));
            
        },
        onMenuItem(path){
            this.$root.$emit('sidepanel-toggle',false);
            this.$router.push(path);
        },
    }
}
</script>

<style lang="less">
.sidebar-menu{
    li{
        color:rgb(29,29,29);
        a{
            padding-left: 20px;
        }
    }
}
</style>